import { render, staticRenderFns } from "./SchoolInfoDownloadOptions.vue?vue&type=template&id=2feb2ed0&scoped=true&"
import script from "./SchoolInfoDownloadOptions.vue?vue&type=script&lang=js&"
export * from "./SchoolInfoDownloadOptions.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInfoDownloadOptions.vue?vue&type=style&index=0&id=2feb2ed0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb2ed0",
  null
  
)

export default component.exports